import type { ProcessedFile } from "@/components/InvoiceList";

type OperationType = NonNullable<ProcessedFile["operationType"]>;
type VatDeductibility = NonNullable<ProcessedFile["vatDeductibility"]>;

/** Master defaults must never replace a deliberate per-invoice selection. */
export const applyReceivedTaxDefaults = <T extends Pick<ProcessedFile, "operationType" | "manualOperationType" | "vatDeductibility">>(
  invoice: T,
  masterOperationType?: OperationType,
): T & { operationType: OperationType } => ({
  ...invoice,
  operationType: invoice.manualOperationType
    ? invoice.operationType ?? "interior"
    : masterOperationType ?? invoice.operationType ?? "interior",
});

export const setReceivedOperationType = <T extends object>(
  invoice: T,
  operationType: OperationType,
): T & { operationType: OperationType; manualOperationType: boolean } => ({ ...invoice, operationType, manualOperationType: true });

export const setReceivedVatDeductibility = <T extends object>(
  invoice: T,
  vatDeductibility: VatDeductibility,
): T & { vatDeductibility: VatDeductibility } => ({ ...invoice, vatDeductibility });